<template>
	<div class="hello">
		<img :src="imgsrc" width="64" height="64" /><br />
		<h1>位置信息：{{ msg }}</h1>
		<h1>二维码信息：{{ codeinfo }}</h1>
		<button @click="getposition(1)">获取位置</button>
		<button @click="getimage('SAVEDPHOTOALBUM')">从文件夹获取</button>
		<button @click="getimage('Camera')">使用相机</button>
		<button @click="getcode()">获取二维码</button><br />
	</div>
</template>

<script>
import logoSrc from '../../assets/logo.png'
export default {
	name: 'Cordova',
	data() {
		return {
			imgsrc: logoSrc,
			msg: 'Welcome to Your Vue.js App',
			codeinfo: '这是初始的二维码信息',
			sourceType: {
				SAVEDPHOTOALBUM: 0,
				Camera: 1
			}
		}
	},
	methods: {
		getposition: function(val) {
			navigator.vibrate(500)
			var me = this
			var onSuccess = function(position) {
				me.msg =
					'Latitude:\t' +
					position.coords.latitude +
					'\n' +
					'Longitude:\t' +
					position.coords.longitude +
					'\n' +
					'Altitude:\t' +
					position.coords.altitude +
					'\n' +
					'Accuracy:\t' +
					position.coords.accuracy +
					'\n' +
					'Altitude Accuracy:\t' +
					position.coords.altitudeAccuracy +
					'\n' +
					'Heading:\t' +
					position.coords.heading +
					'\n' +
					'Speed:\t' +
					position.coords.speed +
					'\n' +
					'Timestamp:\t' +
					position.timestamp +
					'\n'
			}

			// onError Callback receives a PositionError object
			//
			var error = function(error) {
				me.msg = 'code: ' + error.code + '\n' + 'message: ' + error.message + '\n'
			}

			navigator.geolocation.getCurrentPosition(onSuccess, error, {
				maximumAge: 30000,
				timeout: 30000,
				enableHighAccuracy: val
			})
		},
		getimage(type) {
			var me = this
			navigator.camera.getPicture(onSuccess, onFail, {
				quality: 50,
				// destinationType: Camera.DestinationType.FILE_URI,
				// sourceType:0,
				sourceType: me.sourceType[type], // 设置从图片库获取
				destinationType: Camera.DestinationType.DATA_URL
			})

			function onSuccess(imageURI) {
				me.imgsrc = 'data:image/jpeg;base64,' + imageURI
			}

			function onFail(message) {
				alert('Failed because: ' + message)
			}
		},
		getcode() {
			var me = this
			cordova.plugins.barcodeScanner.scan(
				function(result) {
					me.codeinfo =
						'We got a barcode\n' +
						'Result: ' +
						result.text +
						'\n' +
						'Format: ' +
						result.format +
						'\n' +
						'Cancelled: ' +
						result.cancelled
				},
				function(error) {
					alert('Scanning failed: ' + error)
				}
			)
		}
	},
	mounted() {
		document.addEventListener('deviceready', onDeviceReady, false)
		var me = this
		function onDeviceReady() {
			me.msg = 'cordova is ready'
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
	font-weight: normal;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}
</style>
